
import React from 'react';
import { updateEstadoGrupoPlanes } from '../../api/axios';
import { toast } from '../../utilities/appToast';
import { toastEstadoCambio } from '../../utilities/toastEstado';
import PropTypes from 'prop-types';

export default class PlanesListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      estado: props.estado
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.estado !== this.props.estado) {
      this.setState({ estado: this.props.estado });
    }
  }

  handleSwitchChange = async (e) => {
    e.stopPropagation();
    const { idGrupo, idUsuario, filtro, onEstadoActualizado } = this.props;
    const nuevoEstado = this.state.estado === 0 ? 2 : 0;
    try {
      const response = await updateEstadoGrupoPlanes({
        idUsuario: Number.parseInt(idUsuario, 10) || 0,
        id: idGrupo,
        estado: nuevoEstado
      });
      const mensaje = response?.data?.mensaje || 'Estado actualizado';
      this.setState({ estado: nuevoEstado }, () => {
        toastEstadoCambio(mensaje, nuevoEstado);
        if (filtro && typeof filtro.estado === 'number' && typeof onEstadoActualizado === 'function') {
          onEstadoActualizado();
        }
      });
    } catch {
      toast.warn('Error al actualizar el estado');
    }
  };

  handleRowClick = (e) => {
    const { onRowClick } = this.props;
    if (typeof onRowClick !== 'function') return;
    if (e.target.closest('.form-check-input')) return;
    onRowClick(e);
  };

  handleRowKeyDown = (e) => {
    const { onRowClick } = this.props;
    if (typeof onRowClick !== 'function') return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (e.target.closest('.form-check-input')) return;
      onRowClick(e);
    }
  };

  render = () => {
    const { idGrupo, nombre, comision, cantidadPlanes, onRowClick } = this.props;
    const { estado } = this.state;
    const isActivo = estado === 0;
    const cardEstado = isActivo ? 'admin-list-card--vigente' : 'admin-list-card--inactivo';

    return (
      <div
        style={{ border: "none", width: "100%", textAlign: "left" } }
        className={`admin-list-card p-3 ${cardEstado} ${onRowClick ? 'cursor-pointer' : ''}`}
        onClick={this.handleRowClick}
        onKeyDown={this.handleRowKeyDown}
        role={onRowClick ? 'button' : undefined}
        tabIndex={onRowClick ? 0 : undefined}
      >
        <div className="row g-2 g-md-3 align-items-center justify-content-between">
          <div className="col-auto">
            <span className="admin-id-badge">{idGrupo}</span>
          </div>
          <div className="col-12 col-md-5 col-lg-6 text-break">
            <input
              type="text"
              readOnly
              value={nombre ?? ""}
              className="form-control-plaintext admin-list-card__title fw-semibold small mb-0 py-0"
              title="Seleccioná y copiá la descripción"
              style={{ cursor: 'text' }}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
              aria-label="Descripción del grupo de planes"
            />
          </div>
          <div className="col-4 col-md-auto d-flex justify-content-md-end">
            <span className="admin-metric-pill">
              <i className="fas fa-list-ul" aria-hidden="true" />
              {cantidadPlanes} <span className="fw-normal text-body-secondary">planes</span>
            </span>
          </div>
          <div className="col-4 col-md-auto d-flex justify-content-center justify-content-md-end align-items-center">
            <span className="admin-metric-pill">
              {comision}
              <i className="fas fa-percent" aria-hidden="true" />
            </span>
          </div>
          <div className="col-4 col-md-auto d-flex justify-content-end align-items-center">
            <div className="custom-control form-switch admin-estado-switch">
              <input
                type="checkbox"
                className="form-check-input"
                checked={isActivo}
                onChange={this.handleSwitchChange}
                onClick={(e) => e.stopPropagation() }
                aria-label={isActivo ? 'Grupo vigente' : 'Grupo deshabilitado'}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
}
PlanesListItem.propTypes = {
    estado: PropTypes.number,
    idGrupo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filtro: PropTypes.shape({
        estado: PropTypes.number,
    }),
    comision: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombre: PropTypes.string,
    cantidadPlanes: PropTypes.number,
    // Actions props
    onEstadoActualizado: PropTypes.func,
    onRowClick: PropTypes.func,
}